export enum DataOperation
{
    read = 'read',
    write = 'write',
    delete = 'delete'
}
